import { TThunkAction } from '../../types/redux';
import { fetchBuildersProjects } from '../buildersProjects';
import { setTooltipTarget } from './tooltipTarget';
import { mergeFilters } from './savedFilters';

export const applyFilters = (): TThunkAction => {
  return async (dispatch, getState) => {
    const {
      filters: { savedFilters, tooltipTarget },
    } = getState();

    if (tooltipTarget) {
      dispatch(setTooltipTarget(undefined));
    }

    dispatch(fetchBuildersProjects({ filters: savedFilters }));

    dispatch(mergeFilters());
  };
};
